const counterMap: Map<string, number> = new Map();

/**
 * Returns the next number of a global counter. Useful if you need to generate unique idents (e.g. for DOM ids).
 * The function supports different counters, identified by the ident parameter.
 * 
 * @param ident 
 * @param prefix 
 * @returns The generated counter string
 */
export function useGlobalCounter(ident: string = 'default', prefix: string = 'default-'): string {
    let counter = 1;
    if (counterMap.has(ident)) {
        counter = (counterMap.get(ident) || 1) + 1;
    }
    counterMap.set(ident, counter);
    return `${prefix}${counter}`;
}
